import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-dahsboard',
  templateUrl: './new-dahsboard.component.html',
  styleUrls: ['./new-dahsboard.component.css']
})
export class NewDahsboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
